<template>
  <div class="flux">
    <div class="container">
      <div ref="editable" class="editable">
      </div>
    </div>
  </div>
</template>

<script>
import FluxEditor from './flux-editor/core.js';

export default {
  name: 'FluxEditor',
  props: {
    content: String,
    options: {
      type: Object,
      default: {
        plugins: {
          FluxEditorText: {
            active: true,
            events: {}
          },
          FluxEditorList: {
            active: true,
            events: {}
          }
        }
      }
    }
  },
  data () {
    return {
      fluxEditorInstance: null
    }
  },
  mounted () {
    this.$refs.editable.innerHTML = this.content
    this.fluxEditorInstance =  new FluxEditor('.editable', this.options)
  }
}
</script>
<style>

.flux-image {
  text-align: center;
}


</style>
